import React from 'react';
import { Box, Typography, Grid, Paper, useTheme } from '@mui/material';

import QrCode2Icon from '@mui/icons-material/QrCode2';
import PixOutlinedIcon from '@mui/icons-material/PixOutlined';

import Boleto from './Boleto';
import BoletoLote from './BoletoLote';
import PixQRCode from './PixQrCode';
import PixKeys from './PixKeys';

const actionOptions = [
  {
    label: 'Emitir boleto individual (Digitação)',
    icon: <QrCode2Icon fontSize="medium" sx={{ color: 'primary.main' }} />,
    onClick: (setters: any) => setters.setIsEmitirBoletoOpen(true),
  },
  {
    label: 'Emitir boleto em lote (Planilha)',
    icon: <QrCode2Icon fontSize="medium" sx={{ color: 'primary.main' }} />,
    onClick: (setters: any) => setters.setIsEmitirBoletoLoteOpen(true),
  },
  {
    label: 'Emitir PIX QRCode',
    icon: <PixOutlinedIcon fontSize="medium" sx={{ color: 'primary.main' }} />,
    onClick: (setters: any) => setters.setIsEmitirPixQrOpen(true),
  },
  {
    label: 'Minhas chaves PIX',
    icon: <PixOutlinedIcon fontSize="medium" sx={{ color: 'primary.main' }} />,
    onClick: (setters: any) => setters.setIsPixKeysOpen(true),
  },
];

const Actions = () => {
  const theme = useTheme();
  const [isEmitirBoletoOpen, setIsEmitirBoletoOpen] = React.useState(false);
  const [isEmitirBoletoLoteOpen, setIsEmitirBoletoLoteOpen] = React.useState(false);
  const [isEmitirPixQrOpen, setIsEmitirPixQrOpen] = React.useState(false);
  const [isPixKeysOpen, setIsPixKeysOpen] = React.useState(false);

  const setters = {
    setIsEmitirBoletoOpen,
    setIsEmitirBoletoLoteOpen,
    setIsEmitirPixQrOpen,
    setIsPixKeysOpen,
  };

  return (
    <>
      <Box mb={2}>
        <Typography variant="subtitle1" fontWeight={500} mb={2}>
          Como você gostaria de receber?
        </Typography>
        <Grid container spacing={2}>
          {actionOptions.map((option) => (
            <Grid item xs={12} sm={6} md={3} key={option.label}>
              <Paper
                elevation={0}
                onClick={option.onClick ? () => option.onClick(setters) : undefined}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                  gap: 1,
                  p: 2,
                  height: 118,
                  borderRadius: 2,
                  cursor: 'pointer',
                  backgroundColor: theme.palette.grey[100],
                  color: theme.palette.text.primary,
                  transition: 'background-color 0.2s ease',
                  '&:hover': {
                    backgroundColor: theme.palette.grey[200],
                  },
                }}
              >
                <Box sx={{ color: theme.palette.primary.main }}>{option.icon}</Box>
                <Typography variant="body2" fontWeight={500}>
                  {option.label}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Boleto open={isEmitirBoletoOpen} onClose={() => setIsEmitirBoletoOpen(false)} />
      <BoletoLote open={isEmitirBoletoLoteOpen} onClose={() => setIsEmitirBoletoLoteOpen(false)} />
      <PixQRCode open={isEmitirPixQrOpen} onClose={() => setIsEmitirPixQrOpen(false)} />
      <PixKeys open={isPixKeysOpen} onClose={() => setIsPixKeysOpen(false)} />
    </>
  );
};

export default Actions;
